import script from "./ReservationsIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationsIndex.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationsIndex.vue?vue&type=style&index=0&id=2b2df0ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2df0ec"]])

export default __exports__